class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.activeTab = null;
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll(".product-single__image-variants-title");
    this.contents = this.querySelectorAll(".product-single__image-variants-wrapper");
    this.activateTab(this.tabs[0]);

    this.tabs.forEach(tab => {
      tab.addEventListener("click", () => this.activateTab(tab));
    });
  }

  activateTab(selectedTab) {
    this.tabs.forEach(tab => tab.classList.remove("active-tab"));
    this.contents.forEach(content => content.classList.remove("active-content"));

    selectedTab.classList.add("active-tab");
    const contentId = selectedTab.getAttribute("data-tab");
    const activeContent = this.querySelector(`.product-single__image-variants-wrapper[data-content="${contentId}"]`);

    if (activeContent) {
      activeContent.classList.add("active-content");
    }
  }
}

customElements.define("product-tabs", ProductTabs);